import { render, staticRenderFns } from "./GenderCard.vue?vue&type=template&id=f2292a74&"
import script from "./GenderCard.vue?vue&type=script&lang=js&"
export * from "./GenderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports